export const modalDelete = {
	messageProfile:
		"Al confirmar la acción, eliminará permanentemente el perfil fiscal {{ profile }}. ¿Desea continuar?",
	messageGroup:
		"Al confirmar la acción, eliminará permanentemente el grupo fiscal {{ group }}. ¿Desea continuar?",
	profileDeletedSuccess: "¡Perfil fiscal eliminado con éxito!",
	groupDeletedSuccess: "¡Grupo fiscal eliminado con éxito!",
};
